import { connect } from 'react-redux'
import ProductIntegration from '../../../components/products/details/product/details/pane/ProductIntegration'
import * as actions from '../../../state/actions/provider-products/index'
import { IStoreState } from '../../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const integration = state.integrations.items[ownProps.product.integrationId]
  return {
    integration
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductIntegration)



// WEBPACK FOOTER //
// ./src/containers/products/productdetail/ProductIntegration.ts